import React, { useState } from 'react';
import {CollapsableCardBodyActionsContainer} from '@securspace/securspace-ui-kit'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { MoreHoriz, Logout, Edit } from '@mui/icons-material';
import { ModalType, modalTypes } from '../data';
import { InventoryReportViewVO } from '../../../../types/model/valueObject/InventoryReportViewVO';
import { UserType } from '../../../constants/securspace-constants';
import type { Account } from '../../../../types/Account';

interface ActionMenuProps {
    setOpenModal: (modal: ModalType) => void;
    asset: InventoryReportViewVO;
    setAssetBeingActioned: (asset: InventoryReportViewVO) => void;
    account: Pick<Account, 'userType'>;
}

const SupplierCurrentInventoryCardActionsMenu = (props: ActionMenuProps) => {

  const {asset, setAssetBeingActioned, setOpenModal, account} = props;

  const isGateClerk = account?.userType === UserType.GATE_CLERK;

  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>();

  const handleToggleMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      if (event.currentTarget instanceof HTMLButtonElement && !menuAnchorEl) {
          setMenuAnchorEl(event.currentTarget);
      } else {
        handleCloseMenu()
      }
  };

  const handleCloseMenu = () => {
      setMenuAnchorEl(null);
  };

  const handleSelectAction = (type: string) => {
    setOpenModal({type: type, open: true});
    setAssetBeingActioned(asset)
    handleCloseMenu()
  };

  return <CollapsableCardBodyActionsContainer>
        <IconButton
          onClick={handleToggleMenu}
        >
          <MoreHoriz/>
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={() => handleSelectAction(modalTypes.CHECKOUT)}>
                <ListItemIcon>
                  <Logout/>
                </ListItemIcon>
                <ListItemText>Check Out</ListItemText>
              </MenuItem>
              {!isGateClerk && (
                <MenuItem onClick={() => handleSelectAction(modalTypes.EDIT)}>
                  <ListItemIcon>
                    <Edit/>
                  </ListItemIcon>
                  <ListItemText>Edit</ListItemText>
                </MenuItem>
              )}
            </Menu>
        </IconButton>
      </CollapsableCardBodyActionsContainer>
}

export default SupplierCurrentInventoryCardActionsMenu;
